<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>WebAwesome</h1>
					<p waBody="m" waText>Modern, accessible web component library &mdash; buttons, cards, tabs, dialogs, grids, stacks, inputs, overlays, and layout primitives, all wrapped as type-safe CRTP Java builders with dark-mode theming. WebAwesomePageConfigurator injects the CSS/JS bundles and angular-awesome loader module automatically.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:web-awesome</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.webawesome</p>
					<p waBody="s" waText>Built on: WebAwesome 1.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_689" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_690" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;8&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaButton</h4>
								<p waBody="s" waColorText="quiet" waText>Button with variant &#40;Brand, Success, Warning, Danger&#41; and appearance options</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">6 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-button']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaCard</h4>
								<p waBody="s" waColorText="quiet" waText>Card container with outlined/filled/plain appearance variants</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-card']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaStack</h4>
								<p waBody="s" waColorText="quiet" waText>Vertical stack layout with configurable gap</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-stack']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaCluster</h4>
								<p waBody="s" waColorText="quiet" waText>Horizontal cluster layout with wrapping</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-cluster']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaGrid</h4>
								<p waBody="s" waColorText="quiet" waText>CSS Grid layout with configurable min column size</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-grid']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaTag</h4>
								<p waBody="s" waColorText="quiet" waText>Tag/badge component with variant styling</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-tag']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaDivider</h4>
								<p waBody="s" waColorText="quiet" waText>Horizontal divider line</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-divider']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaTabs</h4>
								<p waBody="s" waColorText="quiet" waText>Tab container with tab/panel pairs</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome/wa-tabs']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (8)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Component parity &mdash; Wa&#42; wrappers mirror WebAwesome web components &#40;buttons, inputs, overlays, layout primitives&#41;</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent setters for Variant, Appearance, Placement, and Size attributes</p>
						<p waBody="s" waColorText="quiet" waText>Java-native hydration &mdash; WebAwesomePageConfigurator injects CSS/JS bundles and body theme classes</p>
						<p waBody="s" waColorText="quiet" waText>Dark-mode theming support with configurable theme paths</p>
						<p waBody="s" waColorText="quiet" waText>TypescriptIndexPageConfigurator exported for cross-plugin asset reuse</p>
						<p waBody="s" waColorText="quiet" waText>Layout components: WaGrid, WaStack, WaCluster for responsive layouts</p>
						<p waBody="s" waColorText="quiet" waText>Card, Tag, Button, Divider, Text components with appearance variants</p>
						<p waBody="s" waColorText="quiet" waText>Modular extensibility &mdash; single Maven module exports all component packages</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Card with Tabs</h4>
							<p waBody="s" waColorText="quiet" waText>Create a card containing tabbed content.</p>
							<markdown [data]="mdContent_691" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_692" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (2)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>WebAwesomePageConfigurator injects CSS/JS bundles and body theme classes</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">TypescriptIndexPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Exported for cross-plugin asset reuse</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides TypescriptIndexPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://webawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/WebAwesome</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>